/**
 * Обивка мягкой мебели в панели «Отделка»: ткани и кожа из библиотеки текстур — тот же
 * каталог, что у обоев (`FinishBrowser`): вкладки, разделы по рисунку, поиск, образцы.
 * Клик по образцу одевает выбранный диван или кресло и пишет шаг истории. Ткань ложится
 * в 3D на основной цвет модели, ножки и каркас остаются своими (`Model3D`).
 */
import { useState } from "react";
import type { FabricTextureKind } from "@/shared/catalog";
import { useProjectStore } from "@/shared/store";
import { floorItemOwner } from "@/shared/store/layers/floorItemsStore";
import { useEditorStore } from "@/widgets/editor";
import { useFabricTarget } from "../hooks/useFabricTarget";
import { FABRIC_KINDS, fabricCards } from "../logic";
import { FinishBrowser } from "./FinishBrowser";
import { FabricTargetCard } from "./FabricTargetCard";

export const FabricPanel = () => {
	const target = useFabricTarget();
	const isReadOnly = useEditorStore((s) => s.isReadOnly);
	const [kind, setKind] = useState<FabricTextureKind>(target?.fabric?.kind ?? "fabric");

	const tabs = FABRIC_KINDS.map((tab) => ({
		key: tab.kind,
		label: tab.label,
		cards: fabricCards(tab.kind),
	}));

	return (
		<>
			{target && (
				<div className="shrink-0 border-b border-border bg-bg">
					<FabricTargetCard target={target} />
				</div>
			)}
			<FinishBrowser
				tabs={tabs}
				tab={kind}
				onTab={setKind}
				activeId={target?.item.fabric ?? null}
				disabled={target === null || isReadOnly}
				onPick={(card) => {
					if (!target || isReadOnly) return;
					const owner = floorItemOwner(target.item.id);
					if (!owner) return;
					useProjectStore
						.getState()
						.recordEdit(() =>
							owner.getState().updateFloorItem(target.item.id, { fabric: card.id }),
						);
				}}
			/>
		</>
	);
};
